<template>
  <div>
    <div>
      <NavBar @update-studentID="studentID = $event" />
      <UserPopUpSecondTermLoan ref="loanModal" :studentID="studentID" />
      <AlertBox ref="alertBox" />
      <!-- UserPage content here -->
    </div>
    <div class="red-circle shadow"></div>
    <div class="screen-control">
      <!-- สถานะการกู้ -->
      <div class="p-3 text-black">
        <div class="bg-white shadow">
          <div class="p-2 row">
            <div class="col">
              <h5 class="my-auto p-2">ข้อมูลคำขอ</h5>
            </div>
            <div class="col-md my-auto mx-2">
              <div class="row">
                <div class="col-auto">
                  <p class="m-0">สถานะการกู้:</p>
                </div>
                <div class="col fw-bolder" id="info_loan_status"></div>
              </div>
            </div>
          </div>
          <hr
            style="border: none; height: 2px; background-color: black"
            class="p-0 m-0"
          />

          <!-- User Info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลผู้กู้ยืมเงิน</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="mb-4">
                <p class="col"><b>รูปนักศึกษา</b></p>
                <div
                  v-if="imageUrl()"
                  :style="{
                    width: '200px',
                    aspectRatio: '4 / 3',
                    backgroundImage: `url(${imageUrl()})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                  }"
                ></div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ชื่อ-นามสกุล</b></p>
                    <p class="col-12 col-md" id="Info_user_fullname">-</p>
                  </div>
                </div>

                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>อายุ</b></p>
                    <p class="col-12 col-md" id="Info_user_old">-</p>
                  </div>
                </div>
              </div>

              <div class="row"></div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>เบอร์โทรศัพท์เคลื่อนที่</b></p>
                    <p class="col-12 col-md" id="Info_user_phoneNumber">-</p>
                  </div>
                </div>

                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>บัตรประชาชน</b></p>
                    <p class="col-12 col-md" id="Info_user_citizenID">-</p>
                  </div>
                  <div class="row">
                    <div class="col" v-if="user_citizenID_file">
                      <p><b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชนผู้กู้</b></p>
                    </div>
                    <div
                      class="col-12 col-md"
                      id="Info_user_citizenID_file"
                      v-if="user_citizenID_file"
                    >
                      <a
                        :href="getFileUrl(user_citizenID_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- User's education info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลการศึกษาที่ขอยื่นกู้</p>
            <div class="bg-secondary-subtle">
              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ระดับการศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_lvlStudy">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ปีการศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_yearStudy">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>ภาคเรียน</b></p>
                      <p class="col-12 col-md" id="Info_user_semesterStudy">
                        -
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สถานภาพการเป็นนักศึกษา</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentStatus">-</p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>ประเภทของผู้กู้ยืม</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentType">-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col" v-if="user_transcript_file">
                    <div class="row">
                      <div class="col">
                        <p><b>ใบแสดงผลการศึกษาตลอดหลักสูตร (Transcript)</b></p>
                      </div>
                      <div class="col-12 col-md" id="Info_user_transcript_file">
                        <a
                          :href="getFileUrl(user_transcript_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row" v-if="user_studentCertificate_file">
                      <div class="col">
                        <p><b>หนังสือรับรองการเป็นนักศึกษา</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_user_studentCertificate_file"
                      >
                        <a
                          :href="getFileUrl(user_studentCertificate_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col" v-if="user_courseCertificate_file">
                    <div class="row">
                      <div class="col">
                        <p>
                          <b
                            >หนังสือรับรองรายวิชาที่ต้องลงทะเบียนเรียนจากสถานศึกษาประจำปีสุดท้าย</b
                          >
                        </p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_user_courseCertificate_file"
                      >
                        <a
                          :href="getFileUrl(user_courseCertificate_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-show="show_studentStatus_reason">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เหตุผลการลาพักการศึกษา</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_studentStatus_reason">-</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สำนักวิชา</b></p>
                      <p class="col-12 col-md" id="Info_user_faculty">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>สาขาวิชา</b></p>
                      <p class="col-12 col-md" id="Info_user_fieldStudy">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>รหัสนักศึกษา</b></p>
                      <p class="col-12 col-md" id="Info_user_studentID">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>GPAX</b></p>
                      <div class="col-12 col-md">
                        <p id="Info_user_gpax">-</p>
                        <div class="col-12 col-md" id="Info_user_gpax_file">
                          <a
                            :href="getFileUrl(user_gpax_file)"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-if="user_gpax_file"
                          >
                            <p class="text-primary text-decoration-underline">
                              คลิกเพื่อดูไฟล์
                            </p>
                          </a>
                          <p v-else>-</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>จบการศึกษาระดับ</b></p>
                      <p class="col-12 col-md" id="Info_user_graduateLvl">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b>กิจกรรมจากเว็บไซต์ MFU CHARACTER (MFU333) จำนวน</b>
                      </p>
                      <p
                        class="col-12 col-md"
                        id="Info_Public_Service_Number_MFU333"
                      >
                        -
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_MFU333_File"
                        v-if="Public_Service_MFU333_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_MFU333_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b> กิจกรรมสร้างเอง จำนวน</b></p>
                      <p
                        class="col-12 col-md"
                        id="Info_Public_Service_Number_selfCreated"
                      >
                        -
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_selfCreated_File"
                        v-if="Public_Service_selfCreated_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_selfCreated_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b
                          >เรียน set e-learning, หลักสูตรอื่นๆ ที่กองทุนกำหนด
                          จำนวน</b
                        >
                      </p>
                      <p
                        class="col-12 col-md"
                        id="Info_Public_Service_Number_eLearning"
                      >
                        -
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <div
                        class="col"
                        id="Info_Public_Service_eLearning_File"
                        v-if="Public_Service_eLearning_File"
                      >
                        <a
                          :href="getFileUrl(Public_Service_eLearning_File)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                      <div class="col-12 col-md"></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <b id="info_totalPublicService"></b>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- User's fiance info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลการเงิน</p>
            <div class="bg-secondary-subtle">
              <div class="p-3">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ได้รับค่าใช้จ่ายในชีวิตประจำวัน</b></p>
                      <div class="col-12 col-md" id="Info_dailyFee">-</div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_user_job">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>รายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ได้รับทุนการศึกษาจาก</b></p>
                      <p
                        class="col-12 col-md"
                        id="Info_user_scholarship_income"
                      >
                        -
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row" v-show="income_file">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือน</b
                        >
                      </p>
                      <div
                        class="col-12 col-md"
                        id="Info_income_file"
                        v-if="income_file"
                      >
                        <a
                          :href="getFileUrl(income_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>

                <div class="row">
                  <div class="row">
                    <div class="col"></div>
                  </div>
                </div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="row p-3">
                <div class="col">
                  <div class="row">
                    <p class="col">
                      <b> มีความประสงค์จะขอกู้ยืม<br />เพื่อใช้ในการศึกษา</b>
                    </p>
                    <div class="col-12 col-md" id="Info_loanPurpose">-</div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <hr
                style="border: none; height: 2px; background-color: black"
                class="p-0 m-0"
              />

              <div class="row p-3">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ลักษณะของผู้กู้ยืม</b></p>
                    <p class="col-12 col-md" id="Info_user_loanType">-</p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
            </div>
          </div>

          <!-- User's fan info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลสถานะภาพของผู้กู้ยืม</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_fan_status">-</p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
              <div class="row" v-show="fan_file">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ไฟล์เอกสารสมรส</b></p>
                    <div class="col-12 col-md" id="Info_fan_file">
                      <a
                        :href="getFileUrl(fanFile)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="fanFile"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_fan_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล </b></p>
                      <p class="col-12 col-md" id="Info_fan_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_fan_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_fan_phoneNumber">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_fan_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p><b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชนคู่สมรส</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_fan_citizenID_file"
                        v-if="fan_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(fan_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_fan_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_fan_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_fan_income">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนของคู่สมรส</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_fan_income_file">
                        <a
                          :href="getFileUrl(fan_income_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="fan_income_file"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Siblings Info -->
          <div class="p-3">
            <p class="text-secondary">
              ข้อมูลพี่น้อง (จำนวนพี่น้องไม่รวมผู้กู้ยืม)
            </p>
            <div
              class="p-3 bg-secondary-subtle"
              v-if="siblings && siblings.length > 0"
            >
              <div
                v-for="(sibling, idx) in siblings"
                :key="idx"
                class="mb-3 border-bottom pb-2"
              >
                <div class="fw-bold">พี่น้องคนที่ {{ idx + 1 }}</div>
                <div>
                  สถานะ:
                  {{
                    sibling.status === "working"
                      ? "ทำงานแล้ว"
                      : sibling.status === "studying"
                      ? "กำลังศึกษา"
                      : "-"
                  }}
                </div>
                <div v-if="sibling.status === 'working'">
                  อาชีพ: {{ sibling.job || "-" }}<br />
                  รายได้ต่อปี: {{ sibling.income || "-" }} บาท
                </div>
                <div v-if="sibling.status === 'studying'">
                  ระดับการศึกษา: {{ sibling.educationLevel || "-" }}
                </div>
              </div>
            </div>
            <div v-else class="p-3 bg-secondary-subtle text-muted">
              ไม่มีข้อมูลพี่น้อง
            </div>
          </div>

          <!-- User's father info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลบิดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_dad_status">-</p>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="dad_death_certificate_file">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <p class="col"><b>ชื่อ-นามสกุล</b></p>
                        <p class="col-12 col-md" id="Info_dad_fullname_dead">
                          -
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <p class="col"><b>ใบมรณะบัตรของบิดา</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_dad_death_certificate_file"
                    >
                      <a
                        :href="getFileUrl(dad_death_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="dad_death_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="dad_family_status_certificate_file">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ไฟล์หนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_dad_family_status_certificate_file"
                    >
                      <a
                        :href="getFileUrl(dad_family_status_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="dad_family_status_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_dad_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล </b></p>
                      <p class="col-12 col-md" id="Info_dad_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_dad_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_dad_phoneNumber">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_dad_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p><b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชนบิดา</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_dad_citizenID_file"
                        v-if="dad_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(dad_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_dad_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_dad_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_dad_income">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนของบิดา</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_dad_file">
                        <a
                          :href="getFileUrl(dadFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="dadFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- User's mother info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลมารดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_mom_status">-</p>
                  </div>
                </div>
                <div class="col"></div>
              </div>

              <div class="row" v-show="mom_death_certificate_file">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <div class="row">
                        <p class="col"><b>ชื่อ-นามสกุล</b></p>
                        <p class="col-12 col-md" id="Info_mom_fullname_dead">
                          -
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <p class="col"><b>ใบมรณะบัตรของมารดา</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_mom_death_certificate_file"
                    >
                      <a
                        :href="getFileUrl(mom_death_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="mom_death_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div class="row" v-show="mom_family_status_certificate_file">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>หนังสือรับรองสถานภาพครอบครัวพร้อมสำเนาบัตรข้าราชการ</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_mom_family_status_certificate_file"
                    >
                      <a
                        :href="getFileUrl(mom_family_status_certificate_file)"
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="mom_family_status_certificate_file"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                      <p v-else>-</p>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>

              <div v-show="show_mom_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล</b></p>
                      <p class="col-12 col-md" id="Info_mom_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_mom_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_mom_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p><b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชนมารดา</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_mom_citizenID_file"
                        v-if="mom_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(mom_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่ </b>
                      </p>
                      <p class="col-12 col-md" id="Info_mom_phoneNumber">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_mom_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_mom_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_mom_income">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนของมารดา</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_mom_file">
                        <a
                          :href="getFileUrl(momFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="momFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- dad mom mariage info -->
          <div class="p-3">
            <p class="text-secondary">สถานภาพสมรสของบิดา-มารดา</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>สถานะ</b></p>
                    <p class="col-12 col-md" id="Info_mariage_status">-</p>
                  </div>
                </div>
                <div class="col"></div>
              </div>

              <div class="row" v-if="maritalFile">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>เอกสาร</b></p>
                    <div
                      class="col-12 col-md"
                      id="Info_Marital_status_of_parents_file"
                    >
                      <a
                        :href="getFileUrl(maritalFile)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p class="text-primary text-decoration-underline">
                          คลิกเพื่อดูไฟล์
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md"></div>
              </div>
            </div>
          </div>

          <!-- User's rightful guardian info -->
          <div class="p-3">
            <p class="text-secondary">ข้อมูลผู้แทนโดยชอบธรรม/ผู้ปกครอง</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <p class="col"><b>ผู้แทนโดยชอบธรรม/ผู้ปกครอง</b></p>
                    <p class="col-12 col-md" id="Info_rightful_guardian">-</p>
                  </div>
                </div>
                <div class="col-12 col-md">
                  <div class="row">
                    <p class="col"><b>มีความเกี่ยวข้องเป็น</b></p>
                    <p class="col-12 col-md" id="Info_other_relationship">-</p>
                  </div>
                </div>
              </div>

              <div v-show="show_other_info">
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>ชื่อ-นามสกุล</b></p>
                      <p class="col-12 col-md" id="Info_other_fullname">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อายุ</b></p>
                      <p class="col-12 col-md" id="Info_other_old">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>เลขบัตรประชาชน</b></p>
                      <p class="col-12 col-md" id="Info_other_citizenID">-</p>
                    </div>
                    <div class="row">
                      <div class="col">
                        <p><b>หนังสือยินยอมพร้อมสำเนาบัตรประชาชนผู้อุปการะ</b></p>
                      </div>
                      <div
                        class="col-12 col-md"
                        id="Info_other_citizenID_file"
                        v-if="other_citizenID_file"
                      >
                        <a
                          :href="getFileUrl(other_citizenID_file)"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b>เบอร์โทรศัพท์เคลื่อนที่</b>
                      </p>
                      <p class="col-12 col-md" id="Info_other_phoneNumber">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>อีเมล</b></p>
                      <p class="col-12 col-md" id="Info_other_email">-</p>
                    </div>
                  </div>

                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col"><b>อาชีพ</b></p>
                      <p class="col-12 col-md" id="Info_other_job">-</p>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col"><b>มีรายได้บาท/ปี</b></p>
                      <p class="col-12 col-md" id="Info_other_income">-</p>
                    </div>
                  </div>
                  <div class="col-12 col-md">
                    <div class="row">
                      <p class="col">
                        <b
                          >หนังสือรับรองรายได้พร้อมสำเนาบัตรข้าราชการ/หนังสือรับรองเงินเดือนของผู้แทนโดยชอบธรรม/ผู้ปกครอง</b
                        >
                      </p>
                      <div class="col-12 col-md" id="Info_other_file">
                        <a
                          :href="getFileUrl(otherFile)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="otherFile"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row">
                      <p class="col">
                        <b>หนังสือรับรองการเป็นผู้อุปการะที่ไม่ใช่บิดา-มารดาพร้อมสำเนาบัตรข้าราชการ</b>
                      </p>
                      <div class="col-12 col-md" id="Info_other_file">
                        <a
                          :href="getFileUrl(otherFile_certificate)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="otherFile_certificate"
                        >
                          <p class="text-primary text-decoration-underline">
                            คลิกเพื่อดูไฟล์
                          </p>
                        </a>
                        <p v-else>-</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Description Info -->
          <div class="p-3">
            <p class="text-secondary" id="step5_description_header">ความจำเป็นในการขอกู้ยืมเงิน</p>
            <div class="p-3 bg-secondary-subtle">
              <div class="col">
                <div class="row">
                  <p
                    class="col"
                    id="step5_description"
                    style="white-space: pre-wrap; word-break: break-word"
                  >
                    {{ loanDescription || "-" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Submit button -->
      <div class="px-3 text-black" v-if="loan_status_apporve">
        <button
          class="btn btn-info text-white d-flex align-items-center float-end px-4 py-2"
          :disabled="loan_status_apporve == false || sentFormSuccess"
          @click="confirmBoxForm()"
        >
          <span>ส่งคำร้องขอ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/User/NavBar_user.vue";
import AlertBox from "../AlertBox.vue";
import Swal from "sweetalert2";
import UserPopUpSecondTermLoan from "./User_popUp_secondTerm_Loan.vue";

export default {
  name: "UserPage_loan_secondSemester",
  components: {
    NavBar,
    AlertBox,
    UserPopUpSecondTermLoan,
  },

  data() {
    return {
      ID: "",
      studentID: "",
      show_fan_info: false,
      show_dad_info: false,
      show_mom_info: false,
      show_other_info: false,
      show_studentStatus_reason: false,
      user_citizenID_file: null,

      fan_citizenID_file: null,
      fan_income_file: null,
      fan_File: null,
      dadFile: null,
      dad_citizenID_file: null,
      momFile: null,
      mom_citizenID_file: null,
      otherFile: null,
      other_citizenID_file: null,
      publicFile: null,
      maritalFile: null,
      user_transcript_file: null,
      user_studentCertificate_file: null,
      user_courseCertificate_file: null,
      user_gpax_file: null,
      income_file: null,
      otherFile_certificate: null,
      dad_death_certificate_file: null,
      mom_death_certificate_file: null,
      dad_family_status_certificate_file: null,
      mom_family_status_certificate_file: null,

      siblings: [],
      loanDescription: "",

      user_imageFile: null,
      loan_status_apporve: false,
      sentFormSuccess: false,
    };
  },

  methods: {
    imageUrl() {
      return this.user_imageFile
        ? `${process.env.VUE_APP_API_BASE_URL}${this.user_imageFile}`
        : null;
    },

    async getServerStatus() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/server/status`
        );
        if (response.ok) {
          const serverStatus = await response.json();
          this.studyYear = serverStatus.study_year;
          this.studySemester = serverStatus.study_semester;
          if (serverStatus.server_status == "close") {
            Swal.fire({
              text: "ระบบการยื่นกู้ยังไม่เปิด ณ ขณะนี้",
              icon: "error",
              confirmButtonColor: "#964040",
            });

            return this.$router.replace("/user");
          }
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getRejectCheck() {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/reject/toLoan/check`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (response.ok) {
          const staticData = await response.json();
          if (staticData.message == "not found") {
            this.$refs.loanModal.openRejectBox();
            return false;
          }
          if (staticData.loaning == false) {
            await Swal.fire({
              title: "คุณได้ปฏิเสธการกู้ยืมเงินแล้ว",
              text: "กรุณาติดต่อเจ้าหน้าที่ กยศ. หากคุณมีความประสงค์ที่จะยื่นกู้ยืมอีกครั้ง",
              icon: "warning",
              confirmButtonColor: "grey",
              confirmButtonText: "รับทราบ",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
            this.$router.push("/user");
            return false;
          }
          this.$nextTick(() => {
            if (this.$refs.alertBox) {
              this.$refs.alertBox.showAlert(
                "คุณสามารถยื่นคำขอกู้ยืมได้",
                "success"
              );
            }
          });
          return true;
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getLoanData(value) {
      try {
        // Properly append the query string with a key
        const response = await fetch(
          `${
            process.env.VUE_APP_API_BASE_URL
          }/user/get/loan/data?id=${encodeURIComponent(value)}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (response.ok) {
          const staticData = await response.json();
          // console.log(staticData);

          this.Info_show_data(staticData);
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          // this.$router.replace("/user");
          throw new Error(errorMessage);
        } else {
          // this.$router.replace("/user");
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    async getStudentLoanLast() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/get/loan/last`,
          {
            method: "GET",
            credentials: "include",
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Connection error");
        }

        const lastLoan = await response.json();

        // ✅ ไม่เคยยื่นฟอร์มมาก่อน → อนุญาตให้ยื่น
        if (lastLoan === null) return;

        // 🔧 ป้องกัน bug เทียบ string กับ number
        const lastSemester = lastLoan.user_semesterStudy?.toString();
        const lastYear = lastLoan.user_yearStudy?.toString();
        const nowSemester = this.studySemester?.toString();
        const nowYear = this.studyYear?.toString();

        const sameSemester = nowSemester === lastSemester;
        const sameYear = nowYear === lastYear;

        // เคยยื่นในภาคเรียนเดียวกัน ปีเดียวกัน → บล็อก
        if (sameSemester && sameYear) {
          await Swal.fire({
            title: "คุณได้ทำการยื่นคำขอกู้ยืมแล้ว",
            icon: "warning",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#964040",
          });
          return this.$router.replace("/user");
        }

        // จะยื่นภาค 2 แต่ภาค 1 ไม่ผ่าน → บล็อก
        if (
          nowSemester === "2" &&
          lastSemester === "1" &&
          sameYear &&
          lastLoan.loan_status !== "อนุมัติ"
        ) {
          await Swal.fire({
            title: "ไม่สามารถยื่นคำขอกู้ยืมในภาคเรียนที่ 2 ได้",
            text: "เนื่องจากไม่ได้รับการอนุมัติในภาคเรียนที่ 1",
            icon: "error",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#964040",
          });
          return this.$router.replace("/user");
        }

        // เคสพิเศษ: ภาค 1 ได้ "ผ่านการตรวจสอบ" แล้วจะยื่นภาค 2 → อนุญาต
        if (
          nowSemester === "2" &&
          lastSemester === "1" &&
          sameYear &&
          lastLoan.loan_status === "อนุมัติ"
        ) {
          await this.getRejectCheck(); // ไปเช็กสิทธิ์การกรอกต่อ
        }

        // หากไม่ตรงเคสต้องห้าม → อนุญาตให้โหลดข้อมูลล่าสุดมา
        this.public_id = lastLoan.public_id;
        this.getLoanData(lastLoan.public_id);
      } catch (error) {
        console.error("Loan Check Error:", error.message);
        alert(error.message);
      }
    },

    Info_show_data(datas) {
      const formData = datas;
      // console.log(formData);

      const setStatus = document.getElementById("info_loan_status");
      // show loan status
      switch (formData.loan_status) {
        case "อยู่ระหว่างดำเนินการ":
          setStatus.innerHTML = `<p style="color: orange;" class="my-auto m-0">${formData.loan_status}</p>`;
          break;
        case "อนุมัติ":
          setStatus.innerHTML = `<p style="color: #00cc44;" class="my-auto m-0">${formData.loan_status}</p>`;
          break;
        case "ผ่านการตรวจสอบคุณสมบัติ":
          setStatus.innerHTML = `<p class="text-success my-auto m-0">${formData.loan_status}</p>`;
          this.loan_status_apporve = true;
          break;
        case "อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม":
          setStatus.innerHTML = `<p class="text-secondary my-auto m-0">${formData.loan_status}</p>`;
          break;
        case "รอผลการพิจารณาจากกองทุน กยศ.":
          setStatus.innerHTML = `<p class="text-warning my-auto m-0">${formData.loan_status}</p>`;
          break;
        case "ตีกลับเพื่อแก้เอกสาร":
          setStatus.innerHTML = `<p class="text-primary my-auto m-0">${formData.loan_status}</p>`;
          break;
        case "ไม่อนุมัติ":
          setStatus.innerHTML = `<p class="text-danger my-auto m-0">${formData.loan_status}</p>`;
          break;
        default:
          break;
      }

      // Helper function to update text content
      const setText = (id, text) => {
        const element = document.getElementById(id);
        if (element) element.innerText = text ? text : "-";
      };

      // Set show file
      const fileMappings = {
        Public_Service_MFU333_File: "Public_Service_MFU333_File",
        Public_Service_selfCreated_File: "Public_Service_selfCreated_File",
        Public_Service_eLearning_File: "Public_Service_eLearning_File",
        user_citizenID_file: "user_citizenID_file",
        income_file: "income_file",
        fan_citizenID_file: "fan_citizenID_file",
        fan_income_file: "fan_income_file",
        fan_file: "fanFile",
        dad_file: "dadFile",
        dad_citizenID_file: "dad_citizenID_file",
        mom_file: "momFile",
        mom_citizenID_file: "mom_citizenID_file",
        other_file: "otherFile",
        other_citizenID_file: "other_citizenID_file",
        user_gpax_file: "user_gpax_file",
        user_transcript_file: "user_transcript_file",
        user_studentCertificate_file: "user_studentCertificate_file",
        user_courseCertificate_file: "user_courseCertificate_file",
        other_NonParent_Custody_Certificate_file: "otherFile_certificate",
        Marital_status_of_parents_file: "maritalFile",
        dad_death_certificate_file: "dad_death_certificate_file",
        mom_death_certificate_file: "mom_death_certificate_file",
        dad_family_status_certificate_file:
          "dad_family_status_certificate_file",
        mom_family_status_certificate_file:
          "mom_family_status_certificate_file",
        user_imageFile: "user_imageFile",
      };

      Object.keys(fileMappings).forEach((key) => {
        if (formData[key]) {
          this[key] = true;
          this[fileMappings[key]] = formData[key];
        }
      });

      // User info
      setText(
        "Info_user_fullname",
        `${formData.user_username} ${formData.user_surname}`
      );
      setText("Info_user_old", formData.user_old);
      setText("Info_user_phoneNumber", formData.user_phoneNumber);
      setText("Info_user_citizenID", formData.user_citizenID);

      // Study info
      const studyFields = [
        "user_lvlStudy",
        "user_yearStudy",
        "user_semesterStudy",
        "user_faculty",
        "user_fieldStudy",
        "user_studentID",
        "user_gpax",
        "user_graduateLvl",
        "user_studentStatus",
        "user_studentStatus_reason",
        "user_studentType",
      ];
      if (formData.user_studentStatus === "ลาพักการศึกษา") {
        this.show_studentStatus_reason = true;
      }

      // User financial info
      ["user_loanType"].forEach((field) => {
        setText(`Info_${field}`, formData[field]);
      });
      setText(
        "Info_Public_Service_Number_MFU333",
        `${formData.Public_Service_Number_MFU333} ชั่วโมง`
      );
      setText(
        "Info_Public_Service_Number_selfCreated",
        `${formData.Public_Service_Number_selfCreated} ชั่วโมง`
      );
      setText(
        "Info_Public_Service_Number_eLearning",
        `${formData.Public_Service_Number_eLearning} ชั่วโมง`
      );
      setText(
        "info_totalPublicService",
        `รวม ${
          formData.Public_Service_Number_MFU333 +
          formData.Public_Service_Number_selfCreated +
          formData.Public_Service_Number_eLearning
        } ชั่วโมง`
      );

      let dailyExpensesOptions = JSON.parse(formData.daily_expenses_options);
      let daily_option = "";
      dailyExpensesOptions.forEach((option) => {
        daily_option += `<p class='m-0'>${option}</p>`;
      });
      document.getElementById(`Info_dailyFee`).innerHTML = daily_option;

      let loanPurposeOptions = JSON.parse(formData.loan_purposes_options);
      let purpose_option = "";
      loanPurposeOptions.forEach((option) => {
        purpose_option += `<p class='m-0'>${option}</p>`;
      });
      setText("Info_user_job", `${formData.user_job ?? "-"}`);
      setText("Info_income", `${formData.user_job_income ?? "-"}`);
      setText(
        "Info_user_scholarship_income",
        `${formData.user_scholarship_income ?? "-"}`
      );

      document.getElementById(`Info_loanPurpose`).innerHTML = purpose_option;

      studyFields.forEach((field) => setText(`Info_${field}`, formData[field]));

      setText(
        "Info_fan_status",
        formData.fan_status === "มีคู่สมรส"
          ? "มีคู่สมรส"
          : formData.fan_status === "โสด"
          ? "โสด"
          : ""
      );
      if (formData.fan_status === "มีคู่สมรส") {
        setText(
          "Info_fan_fullname",
          `${formData.fan_name} ${formData.fan_surname}`
        );
        this.show_fan_info = true;
        [
          "fan_old",
          "fan_citizenID",
          "fan_phoneNumber",
          "fan_email",
          "fan_job",
          "fan_income",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
      }

      setText(
        "Info_dad_status",
        formData.fan_status === "มีชีวิตอยู่"
          ? "มีชีวิตอยู่"
          : formData.fan_status === "เสียชีวิต"
          ? "เสียชีวิต"
          : "ไม่ทราบ"
      );
      if (formData.dad_status === "มีชีวิตอยู่") {
        setText(
          "Info_dad_fullname",
          `${formData.dad_name} ${formData.dad_surname}`
        );
        this.show_dad_info = true;
        [
          "dad_old",
          "dad_citizenID",
          "dad_phoneNumber",
          "dad_email",
          "dad_job",
          "dad_income",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
      }

      if (formData.dad_status === "เสียชีวิต") {
        setText(
          "Info_dad_fullname_dead",
          `${formData.dad_name} ${formData.dad_surname}`
        );
      }

      // Mom info
      setText(
        "Info_mom_status",
        formData.mom_status === "มีชีวิตอยู่"
          ? "มีชีวิตอยู่"
          : formData.mom_status === "เสียชีวิต"
          ? "เสียชีวิต"
          : "ไม่ทราบ"
      );

      if (formData.mom_status === "มีชีวิตอยู่") {
        this.show_mom_info = true;
        setText(
          "Info_mom_fullname",
          `${formData.mom_name} ${formData.mom_surname}`
        );
        [
          "mom_old",
          "mom_citizenID",
          "mom_phoneNumber",
          "mom_email",
          "mom_job",
          "mom_income",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
      }

      if (formData.mom_status === "เสียชีวิต") {
        setText(
          "Info_mom_fullname_dead",
          `${formData.mom_name} ${formData.mom_surname}`
        );
      }

      // Parent's marital status
      setText("Info_mariage_status", formData.Marital_status_of_parents);

      // Rightful guardian
      setText("Info_rightful_guardian", formData.rightful_guardian);
      if (formData.rightful_guardian === "ผู้ปกครองไม่ใช่บิดา มารดา") {
        this.show_other_info = true;
        setText(
          "Info_other_fullname",
          `${formData.other_name} ${formData.other_surname}`
        );
        [
          "other_old",
          "other_citizenID",
          "other_phoneNumber",
          "other_email",
          "other_job",
          "other_income",
          "other_relationship",
        ].forEach((field) => {
          setText(`Info_${field}`, formData[field]);
        });
      }
      // Siblings info
      if (
        formData.siblings &&
        formData.siblings !== "null" &&
        formData.siblings !== null
      ) {
        try {
          this.siblings = JSON.parse(formData.siblings);
          // console.log("Parsed siblings:", this.siblings);
        } catch (e) {
          console.error("Error parsing siblings:", e);
          this.siblings = [];
        }
      } else {
        // console.log("No siblings data found or data is null");
        this.siblings = [];
      }

       if (
        formData.user_studentType ===
        "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร"
      ) {
        setText(
          "step5_description_header",
          "เหตุผลที่ไม่สามารถสำเร็จการศึกษาตามหลักสูตร"
        );
      }
      
      // Description info
      this.loanDescription =
        formData.description || formData.loanDescription || "";
    },

    getFileUrl(filePath) {
      if (!filePath || typeof filePath !== "string") return "#"; // Check for invalid input

      // Prevent path traversal by allowing only specific prefixes
      if (!filePath.startsWith("/uploads/")) return "#";

      const baseUrl = `${process.env.VUE_APP_API_BASE_URL}` || `localhost:3000`;

      return `${baseUrl}${filePath}`;
    },

    async confirmBoxForm() {
      if (this.isSubmitting) return;
      const result = await Swal.fire({
        title: "คุณแน่ใจหรือไม่",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#964040",
      });

      if (result.isConfirmed) {
        this.postSubmitForm();
      }
    },

    async postSubmitForm() {
      if (this.isSubmitting || this.sentFormSuccess) return; // Prevent if already submitting or already submitted
      this.isSubmitting = true;

      const canSubmit = await this.getRejectCheck();
      if (!canSubmit) {
        this.isSubmitting = false;
        return;
      }

      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/user/loan/submit_form/secondSemester`,
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ public_id: this.public_id }),
          }
        );

        const contentType = response.headers.get("Content-Type") || "";

        if (response.ok) {
          const res = await response.json();
          this.sentFormSuccess = true;

          // ✅ Swal replaces setTimeout
          await Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$router.push("/user");
        } else if (contentType.includes("application/json")) {
          const errorPayload = await response.json();
          throw new Error(
            errorPayload.message ||
              errorPayload.error ||
              `Unexpected server error (${response.status})`
          );
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        this.$refs.alertBox.showAlert(error.message, "error");
      } finally {
        this.isSubmitting = false;
      }
    },

    showConsentIfNeeded() {
      const consentKey = "loanConsentDate";
      const lastConsent = localStorage.getItem(consentKey);

      const isMoreThan7Days = (dateString) => {
        const lastDate = new Date(dateString);
        const now = new Date();
        const diff = now - lastDate;
        const Days = 3 * 24 * 60 * 60 * 1000;
        return diff > Days;
      };

      if (!lastConsent || isMoreThan7Days(lastConsent)) {
        return Swal.fire({
          title: "ยืนยันการเปิดเผยข้อมูลส่วนบุคคล",
          icon: "warning",
          html: `
        <div style="text-align: left; font-size: 14px; line-height: 1.6;">
          <p>1. ข้าพเจ้ายินยอมให้กองทุนเงินให้กู้ยืมเพื่อการศึกษา ขอข้อมูลส่วนบุคคลของข้าพเจ้าจากหน่วยงานหรือองค์กร ทั้งภาครัฐ เอกชน หรือบุคคลใด ซึ่งเป็นผู้ครอบครองข้อมูลของข้าพเจ้า เพื่อการให้กู้ยืม การติดตามหนี้ และการดำเนินการใด ๆ ได้ตามวัตถุประสงค์ของกองทุนเงินให้กู้ยืมเพื่อการศึกษา</p>
          <p>2. ข้าพเจ้ายินยอมให้หน่วยงานหรือองค์กร ทั้งภาครัฐ เอกชน หรือบุคคลใด ซึ่งเป็นผู้ควบคุมหรือครอบครองข้อมูลของข้าพเจ้า เปิดเผย และ/หรือ แลกเปลี่ยนข้อมูลส่วนบุคคลของข้าพเจ้า ให้แก่กองทุนเงินให้กู้ยืมเพื่อการศึกษา เพื่อการให้กู้ยืม การติดตามหนี้ และการดำเนินการใด ๆ ได้ตามวัตถุประสงค์ของกองทุน</p>
          <p>3. ข้าพเจ้าจะไม่เพิกถอนการให้ความยินยอมตามหนังสือนี้ เว้นแต่จะได้รับความเห็นชอบจากกองทุนเงินให้กู้ยืมเพื่อการศึกษาเป็นลายลักษณ์อักษร</p>
          <p>4. ให้ถือว่าคู่ฉบับและบรรดาสำเนาภาพถ่าย ข้อมูลอิเล็กทรอนิกส์ หรือโทรสารที่ทำสำเนาขึ้นจากหนังสือให้ความยินยอมฉบับนี้ ไม่ว่าในรูปแบบใด ๆ เป็นหลักฐานในการให้ความยินยอมของข้าพเจ้าเช่นเดียวกัน</p>
          <p><strong>กรุณาอ่าน <a href="https://pdpa.mfu.ac.th/pdpa-6250.html" target="_blank">นโยบายความเป็นส่วนตัว</a> ก่อนดำเนินการต่อ</strong></p>
        </div>
      `,
          input: "checkbox",
          inputValue: 0,
          inputPlaceholder:
            "ข้าพเจ้าได้อ่านและเข้าใจข้อความในหนังสือให้ความยินยอมในการเปิดเผยข้อมูลฉบับนี้โดยตลอดแล้ว",
          confirmButtonText: "ยินยอมและดำเนินการต่อ",
          confirmButtonColor: "#3085d6",
          inputValidator: (result) => {
            return !result && "กรุณายืนยันความยินยอมก่อนดำเนินการต่อ";
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: true,
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem(consentKey, new Date().toISOString());
          }
        });
      } else {
        // ✅ return a resolved promise if no need to show popup
        return Promise.resolve();
      }
    },
  },

  mounted() {
    this.getServerStatus();
    this.showConsentIfNeeded();
  },

  unmounted() {},
  watch: {
    studentID(newValue) {
      if (newValue == "") {
        Swal.fire({
          text: "เกิดข้อผิดพลาดในการดึงข้อมูลนักศึกษา",
          icon: "error",
          confirmButtonColor: "#964040",
        });
        return this.$router.push("/user");
      } else {
        this.getStudentLoanLast();
      }
    },
  },
};
</script>

<style scoped>
.red-circle {
  position: absolute;
  width: 100%;
  height: 40%;
  background-color: #964040;
  z-index: -1;
}

/* To Make Sure h1-h6 don't have extended space */
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}

.con-header {
  color: white;
  background-color: #964040;
}

.screen-control {
  height: 100vh;
  min-height: 100%;
  padding: 5rem 20vw;
}
@media (max-width: 768px) {
  .screen-control {
    padding: 5rem 2vw;
  }
}
</style>
